import {
  PARK_USER_BULK_UPLOAD_REQUEST,
  PARK_USER_BULK_UPLOAD_SUCCESS,
  PARK_USER_BULK_UPLOAD_FAILURE,
} from "../actions/parkUserBulkUploadActions";

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const parkUserBulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARK_USER_BULK_UPLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case PARK_USER_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case PARK_USER_BULK_UPLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default parkUserBulkUploadReducer;
